<template>
  <v-container class="home">
    <v-row>
      <v-col  cols="12" lg="10" offset-lg="1">
        <div class="overline ">home
        </div>
        <h1 class="primary--text my-6">
          <strong>👋 Fáilte {{currentUser.user.username}}</strong>
        </h1>
        <tuto-info>
          <h4 class="pa-2">Home Page</h4>
          <p class="pa-2">
            <strong class="primary--text">Ceol</strong> allows you to create practice <strong>Sets</strong> of your favourite <strong>Tunes.</strong>
          </p>
          <p class="pa-2">
            Your <strong class="primary--text">Home Page</strong> allows you to navigate around the different parts of the site. Come back here by clicking <strong class="overline primary--text">HOME</strong> or the <strong class="primary--text">Ceol</strong> logo at the top of the page
          </p>
        </tuto-info>
        <v-row>
          <v-col cols="12" md="4" lg="3">
            <v-card :color="isDark ? 'grey darken-2' : 'grey lighten-1'"  class="fill-height white--text mx-auto" large to="/tunes"  max-width="320">
              <v-img
              height="320"
              src="tune.jpeg"
              ></v-img>
              <v-card-title>
                <v-icon  class="white--text">mdi-music-note</v-icon> Browse {{tunes.length}} Tunes
              </v-card-title>
              <v-card-text>Explore Ceol's library of over {{ tunes.length }} tunes</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-card :color="isDark ? 'grey darken-2' : 'grey lighten-1'" class="fill-height white--text mx-auto" large to="/sets" max-width="320">
              <v-img
                height="320"
                src="session.jpeg"
              ></v-img>
              <v-card-title>
                <v-icon class="white--text">mdi-playlist-music</v-icon> Find & Create Sets
              </v-card-title>
              <v-card-text>Find sets to practice or create your own!</v-card-text>
            </v-card>
          </v-col>
          <!-- <v-col cols="12" md="4" lg="3">
            <v-card disabled :color="isDark ? 'grey darken-2' : 'grey lighten-1'" class="fill-height white--text mx-auto" large to="/sets" max-width="320">
              <v-img
                height="320"
                src="record.jpeg"
              ></v-img>
              <v-card-title>
                <v-icon class="white--text" color="">mdi-microphone</v-icon> Record your own sets.
              </v-card-title>
              <v-card-text><v-alert dense  type="info">
                Coming soon ;)
              </v-alert></v-card-text>
            </v-card>
          </v-col> -->
          <v-col cols="12" md="4" lg="3">
            <v-card :color="isDark ? 'grey darken-2' : 'grey lighten-1'" class="fill-height white--text mx-auto" large to="/recordings" max-width="320">
              <v-img
                height="320"
                src="recordings.jpeg"
              ></v-img>
              <v-card-title>
                <v-icon class="white--text" color="">mdi-speaker-wireless</v-icon> Set recordings
              </v-card-title>
              <v-card-text>
                Explore different recordings of sets.
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-card :color="isDark ? 'grey darken-2' : 'grey lighten-1'" class="fill-height white--text mx-auto" large to="/profile" max-width="320">
              <v-img
                height="320"
                src="settings.jpeg"
              ></v-img>
              <v-card-title>
                <v-icon class="white--text" color="">mdi-wrench</v-icon> Configure Ceol.
              </v-card-title>
              <v-card-text>Control how Ceol works & plays with you</v-card-text>
            </v-card>
          </v-col>

          
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TutoInfo from '@/layout/TutoInfo.vue';

export default {
  name: 'PrivateHomeView',
  data() {
    return {
      tutoInfo: true
    }
  },
  components: {
    TutoInfo
  },
  mounted() {
    this.$store.dispatch('tune/getSetList');
    this.$store.dispatch('tune/getTuneList');
    this.$store.dispatch('tune/getUserProfile');
  },
  methods: {
    disableHelp() {
      this.$store.dispatch('tune/updateUserProfile', {
        id: this.userProfile.id,
        data: { user_settings: { help_text: false } }
      });
    }
  },
  computed: {
    hasHelp() {
      if (!this.userProfile.user_settings)
        return true
      return this.userProfile.user_settings.help_text;
    },
    isDark(){
      return this.$vuetify.theme.dark
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    userProfile() {
      return this.$store.state.tune.userProfile;
    },
    sets() {
      return this.$store.state.tune.sets;
    },
    tunes() {
      return this.$store.state.tune.tunes;
    }
  },

}
</script>
<style lang="scss" scoped>
.home {
}
.v-card { 
  transition: transform 0.2s ease-in-out;
}
.v-image__image--cover { 
  // transition: transform 1s ease-in-out;
  // transform: scale(1.01);
}
.v-card:hover {
  transform: scale(1.1);
    .v-image__image--cover { 
      // transform: scale(1.1);
    }
}
</style>